<template>
  <div class="w-full flex flex-col">
    <img  id="video-player" @click="toggleImage" alt="cam_image" class="w-full" :src="errorCamera ? getBaseImageUrl(image) : getVideoFrame" />

    <div class="w-full" v-if="!errorCamera">
      <h5 class="py-2 w-full">Kontroller</h5>
      <p-t-z-controller :event="event"/>
    </div>
  </div>
</template>

<script>
import PTZController from './PTZController'
export default {
  name: 'CamController',
  components: {
    PTZController
  },
  props: {
    camera_id: {
      type: String
    },
    image: {
      type: String
    },
    event: {
      type: Object
    }
  },
  data () {
    return {
      image_to_show: '',
      fps: 1,
      second: 1000,
      intervalObject: null,
      frame_counter: 0,
      errorCamera: true
    }
  },
  watch: {
    '$store.state.cam_images' (val) {
      this.showCamImages(val)
    }
  },
  computed: {
    showPopup () { return this.$store.state.showPopup },
    cam_images () {
      return this.$store.state.cam_images
    },
    getVideoFrame () {
      return this.image_to_show
    }
  },
  mounted () {
    this.errorCamera = true
    this.getCamImages()
  },
  methods: {
    toggleImage () {
      console.log('got event', event)
      this.$store.commit('TOGGLE_POPUP', !this.showPopup)
      if (this.errorCamera) {
        this.$store.commit('SET_EVENT_IMAGE', this.getBaseImageUrl(this.image))
      } else {
        this.$store.commit('SET_EVENT_IMAGE', this.image_to_show)
      }

      console.log('popup', this.showPopup)
    },
    showCamImages (val) {
      if (!this.intervalObject) {
        this.frame_counter = 0
        this.intervalObject = setInterval(() => {
          if (this.frame_counter === this.cam_images.length) {
            clearInterval(this.intervalObject)
            this.intervalObject = null
            this.frame_counter = 0
            setTimeout(() => {
              this.getConsecutiveImages()
            }, 1000)
            return
          }

          if (val[this.frame_counter]) {
            if (val[this.frame_counter].image) {
              this.image_to_show = this.getImageUrl(val[this.frame_counter].image)
            }
          }

          //if (this.showPopup) {
          this.$store.commit('SET_EVENT_IMAGE', this.image_to_show)
          //}
          this.frame_counter += 1
        }, this.second / this.fps)
      }
    },
    getImageUrl (path) {
      return 'https://api.arftower.com/static/frames/'.concat(path)
    },
    getBaseImageUrl (path) {
      if (!path.includes('https')) {
        return 'https://api.arftower.com/'.concat(path)
      } else {
        return path
      }

    },
    getConsecutiveImages () {
      const payload = {
        id: this.camera_id,
        images: this.cam_images
      }
      this.$store.dispatch('getConsecutiveImages', payload)
        .then(() => {
          this.errorCamera = false
        })
        .catch(error => {
          console.log('error', error)

          this.errorCamera = true
          this.$vs.notify({
            title: 'Sorun',
            text: error.response.data.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning'
          })
        })
    },
    getCamImages () {
      const payload = {
        id: this.camera_id
      }
      console.log('cam image payload', payload)
      this.$store.dispatch('getCamImages', payload)
        .then((response) => {
          this.errorCamera = false
          this.$vs.notify({
            title: 'Başarılı',
            text: 'Kamera başlatıldı',
            iconPack: 'feather',
            icon: 'icon-alert-check',
            color: 'success'
          })
          console.log('cam images', response)
        })
        .catch(error => {
          console.log('error', error)
          this.$vs.notify({
            title: 'Sorun',
            text: error.response.data.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning'
          })
          this.showCamImages(this.cam_images)
          this.errorCamera = true
        })
    }
  }
}
</script>

<style lang="scss">

</style>
